// page-pedidos-wrapper.component.ts

import { Component, OnInit } from "@angular/core";
import { Configuracoes } from "src/app/core/entities/configuracoes";

@Component({
  selector: "app-page-pedidos-wrapper",
  template: `
    <app-page-pedidos *ngIf="!isB2c"></app-page-pedidos>
    <app-lista-pedido-b2c *ngIf="isB2c"></app-lista-pedido-b2c>
  `,
})
export class PagePedidosWrapperComponent implements OnInit {
  isB2c = false;

  constructor() {
    this.isB2c = Configuracoes.layoutB2c
  }

  ngOnInit() {
    this.isB2c = Configuracoes.layoutB2c
  }
}